import { Post } from "./Post/Post";
import styles from "./Feed.module.scss";
import { Button } from "@/components/Button/Button";
import { InstagramPost, InstagramSettings } from "@/wp/getInstagram";
import { StaggerAnimation } from "@/components/Animation";

interface FeedProps {
  props: {
    images: InstagramPost[];
    canLoadMore: boolean;
    loadMore: () => void;
    loadMoreText: string;
    followUrl?: string;
    followText: string;
    settings: InstagramSettings;
    loading: boolean;
    cols: number;
    initialFullRows: number;
    postSizes: string;
    modalAnimation: boolean;
  };
}

export const Feed = ({ props }: FeedProps) => {
  const { box, show_loadmore } = props.settings.acf;

  const { show_border_radius, show_box_shadow, show_card_box } = box ?? {};

  const { canLoadMore, loadMore, followText, followUrl, loadMoreText } = props;

  const buttonsJSX = (
    <div className="sbi_load">
      <div className="insta-buttons">
        <div className="load-more-container is-flex is-justify-content-center">
          {canLoadMore ? (
            <Button
              type="primary"
              href={""}
              target=""
              disabled={props.loading}
              onClick={() => {
                loadMore();
              }}
              className="mx-auto"
            >
              {loadMoreText}
            </Button>
          ) : followUrl ? (
            <Button
              type="primary"
              href={followUrl}
              target="_blank"
              className="mx-auto"
            >
              {followText}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );

  const imagesJSX = (
    <StaggerAnimation
      staggerDelay={500}
      maxStaggerIndex={props.initialFullRows * props.cols}
      staggerGroupSize={props.cols}
      className={styles["sbi-images"]}
      animation="fade-in-up-light"
    >
      {[
        ...props.images,
        ...(props.loading
          ? [
              ...Array.from({ length: props.cols }).map(
                () =>
                  ({
                    id: "loading",
                    caption: "",
                    media_type: "image",
                    media_url: "",
                    permalink: "",
                    timestamp: "",
                    thumbnail_url: "",
                    children: null,
                  }) as InstagramPost,
              ),
            ]
          : []),
      ].map((post, i) => (
        <div key={i}>
          <Post
            post={post}
            show_border_radius={show_border_radius ?? false}
            show_box_shadow={show_box_shadow ?? false}
            show_card_box={show_card_box ?? false}
            skeleton={post.id === "loading"}
            postSizes={props.postSizes}
            modalAnimation={props.modalAnimation}
          />
        </div>
      ))}
    </StaggerAnimation>
  );
  return (
    <>
      {imagesJSX} {show_loadmore && buttonsJSX}
    </>
  );
};
